module.exports = {
    DutchCustomsNewsFeed: 'Douane voor bedrijven',
    NewsOverview: 'Nieuwsoverzicht',
    OpenInTaricSupport: 'Open in Taric Support'
};